<!-- Ext Cluster Analytics -  Clusters -->

  <div class="card" *ngIf="this.clusters && this.clusters[0] != null">
    <app-kontable
    id="ext_cluster_analytics"
    [ngClass]="{'no-pagination-table': clusters.length <= 20}"
    title="{{ 'extClusterAnalytics.sectionTitle' | translate }}"
    [columns]="['modello', 'descrizione', 'value', 'score']"
    [titles]="['extClusterAnalytics.model', 'extClusterAnalytics.description', 'extClusterAnalytics.value', 'extClusterAnalytics.score']"
    [source]="this.clusters"
    [showInfoButton]="false"
    [showRecoverButton]="false"
    [showDetailsButton]="false"
    [showReport]="false"
    [showEditButton]="false"
    [showDeleteButton]="false"
    [showAddButton]="false"
    [showGlobalFilter]="false"
    [DefaultRowsPerPage]="20"
  >
  </app-kontable>

  </div>

  <div class="card" *ngIf="!this.clusters || this.clusters[0] == null">
    <p>{{ 'extClusterAnalytics.noCluster' | translate }}</p>
  </div>




  <!-- Ext Cluster Analytics - Common Info -->
  <div class="ui-g-12 card-common" *ngIf="this.common">
    <div class="ui-g-12">
      <!-- Codice Cliente -->
      <div class="ui-g-12 ui-md-3">
        <label>{{ 'extClusterAnalytics.customerCode' | translate }}</label>
        <span>{{ this.common.codice_cliente }}</span>
      </div>
      <!-- Codice Cliente Alfanumerico -->
      <div class="ui-g-12 ui-md-3">
        <label>{{ 'extClusterAnalytics.customerCodeAlpha' | translate }}</label>
        <span>{{ this.common.codice_cliente_alfanumerico }}</span>
      </div>
      <!-- Date Prima Transazione -->
      <div class="ui-g-12 ui-md-3">
        <label>{{ 'extClusterAnalytics.dateFirstTransaction' | translate }}</label>
        <span>{{ this.common.data_prima_transazione | date:'dd/MM/yyyy' }}</span>
      </div>
      <!-- Data Ultima Transazione -->
      <div class="ui-g-12 ui-md-3">
        <label>{{ 'extClusterAnalytics.dateLastTransaction' | translate }}</label>
        <span>{{ this.common.data_ultima_transazione | date:'dd/MM/yyyy' }}</span>
      </div>
    </div>
    <div class="ui-g-12">
      <!-- Data di Riferimento -->
      <div class="ui-g-12 ui-md-3">
        <label>{{ 'extClusterAnalytics.dateReference' | translate }}</label>
        <span>{{ this.common.data_riferimento }}</span>
      </div>
      <!-- Frequenza -->
      <div class="ui-g-12 ui-md-3">
        <label>{{ 'extClusterAnalytics.frequency' | translate }}</label>
        <span>{{ this.common.frequenza }}</span>
      </div>
      <!-- Importo Spesa Totale -->
      <div class="ui-g-12 ui-md-3">
        <label>{{ 'extClusterAnalytics.totalExpenseAmount' | translate }}</label>
        <span>{{ this.common.importo_spesa_totale }} €</span>
      </div>
      <!-- Scontrino Medio -->
      <div class="ui-g-12 ui-md-3">
        <label>{{ 'extClusterAnalytics.averageReceipt' | translate }}</label>
        <span>{{ this.common.scontrino_medio }} €</span>
      </div>
    </div>
  </div>

  <div class="ui-g-12 card-common" *ngIf="!this.common">
    <p>{{ 'extClusterAnalytics.noCommonInfo' | translate }}</p>
  </div>





// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/ext-cluster-analytics/ext-cluster-analytics.component.html